<template>
  <div class="page00">
    <div
      class="bdground"
      :style="{ height: screenHeight + 'px', width: screenHeight + 'px' }"
    >
      <img
        ref="img"
        src="../../../../assets/img/mobile/p-00-homepage/bdg.png"
      />
    </div>
    <div class="logo"></div>
    <div class="text">数字化新零售解决方案</div>
    <!-- <div class="text__tips">让营销执行更有效率</div> -->
  </div>
</template>
<script>
export default {
  props: {
    screenHeight: {
      type: [Number, String],
      default: 601
    }
  },
  data() {
    return {
      Oheight: "",
      Owidth: ""
    };
  },
  mounted() {
    console.log(this.screenHeight);
    this.Oheight = this.screenHeight;
    this.Owidth = this.screenHeight;
    this.$refs.img.onload = function() {};
  }
};
</script>
<style lang="scss" scoped>
.page00 {
  // line-height: 11.32rem;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  z-index: 0;
  overflow: hidden;
  background: #fff;
  .bdground {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 50%;
    width: auto;
    height: 100%;
    z-index: 0;
    transform: translateX(-50%);
    transform-origin: 0% 50%;
    img {
      height: 100%;
      width: auto;
    }
    // background-size: auto 100%;
    // background-repeat: no-repeat;
    // background-position: center center;
    // background-image: url("../../../../assets/img/mobile/p-00-homepage/bdg.png");
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
    animation: play 8s linear 1;
  }
  .logo {
    width: 100%;
    height: 0.8rem;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url("../../../../assets/img/mobile/p-00-homepage/logo.png");
    position: relative;
    z-index: 1;
  }
  .text {
    padding: 0.28rem 0;
    width: 100%;
    line-height: 0.6rem;
    font-size: 0.44rem;
    font-weight: bold;
    color: rgba(41, 43, 58, 1);
    position: relative;
    z-index: 1;
  }
  .text__tips {
    width: 100%;
    font-size: 0.32rem;
    font-weight: bold;
    line-height: 0.6rem;
    color: rgba(41, 43, 58, 0.7);
    position: relative;
    z-index: 1;
  }
}
@keyframes play {
  0% {
    transform: rotate(0deg) translateX(-50%);
  }
  100% {
    transform: rotate(-360deg) translateX(-50%);
  }
}
</style>
